// Angular dependencies
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Imports modules
import { PageMainComponent } from './page-main.component';
import { PageCreepComponent } from '../page-creep.module';

const routes: Routes = [{
  path: '',
  component: PageMainComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PageMainRouterModule {
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/page-main.router.ts